import { ErrorInterface } from "anatoliapps-angular/utils";

//#region Auth Error
/**
 * Auth error codes.
 */
export enum AuthErrorCode {
  // Action Codes
  INVALID_ACTION_CODE = 'auth/invalid-action-code',

  // Authorization Codes
  NOT_AUTHORIZED = 'auth/not-authorized',

  // Sign Codes
  EMAIL_ALREADY_IN_USE = 'auth/email-already-in-use',
  INVALID_CREDENTIAL = 'auth/invalid-credential',
  TOO_MANY_REQUESTS = 'auth/too-many-requests',

  // User Codes
  USER_NOT_FOUND = 'auth/user-not-found',
}

/**
 * Auth error messages of error codes.
 */
export const AuthErrorMessage = {
  // Action Code Messages
  [AuthErrorCode.INVALID_ACTION_CODE]: 'Bu doğrulama linki geçersiz veya süresi dolmuş. Lütfen yeni bir doğrulama bağlantısı talep edin.',

  // Authorization Code Messages
  [AuthErrorCode.NOT_AUTHORIZED]: 'Bu işlemi gerçekleştirmek için yetkiniz yok. Lütfen yöneticinizle iletişime geçin.',

  // Sign Code Messages
  [AuthErrorCode.EMAIL_ALREADY_IN_USE]: 'Bu e-posta adresi zaten kullanımda. Lütfen farklı bir e-posta adresi ile kayıt olmayı deneyin.',
  [AuthErrorCode.INVALID_CREDENTIAL]: 'Lütfen e-posta adresinizi ve şifrenizi kontrol ediniz.',
  [AuthErrorCode.TOO_MANY_REQUESTS]: 'Çok fazla geçersiz giriş denemesi yapıldı. Lütfen bir süre sonra tekrar deneyin.',

  // User Code Messages
  [AuthErrorCode.USER_NOT_FOUND]: 'Bu kullanıcı bulunamadı. Lütfen e-posta adresinizi kontrol edin veya yeni bir hesap oluşturun.'
} as const;

/**
 * Auth error structure. This extends Error.
 */
export class AuthError extends Error implements ErrorInterface {

  /**
   * Auth error extended class.
   * 
   * @param code - Auth error code.
   */
  constructor(public readonly code: string) {
    super(AuthErrorMessage[code as keyof typeof AuthErrorMessage] || `An unknown auth error (${code}) occurred.`);

    /* tslint:disable:max-line-length */
    // Set the prototype explicitly. See the following link for more details:
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    /* tslint:enable:max-line-length */
    Object.setPrototypeOf(this, AuthError.prototype);
  }

  //#region Error Instances
  /** The error instance for if credentials are invalid. */
  public static get INVALID_CREDENTIAL() { return new AuthError(AuthErrorCode.INVALID_CREDENTIAL); }
  //#endregion

}
//#endregion